<template>
  <div ref="menu">
    <template
      v-if="
        data.data.db == 'filesystem' ||
        data.data.db == 'public' ||
        data.data.db == 'group'
      "
    >
      <template v-if="!data.data.is_group">
        <ul @click="close2">
          <li
            @click="view_doc_file"
            v-if="
              (!data.data.is_dir && data.data.extname === '.docx') ||
              data.data.extname === '.doc' ||
              data.data.extname === '.xlsx' ||
              data.data.extname === '.xls' ||
              data.data.extname === '.pptx' ||
              data.data.extname === '.ppt' ||
              data.data.extname === '.wopitest'
            "
          >
            <i class="fa fa-eye"></i> View File
          </li>
          <li
            @click="edit_doc_file"
            v-if="
              (!data.data.is_dir && data.data.extname === '.docx') ||
              data.data.extname === '.doc' ||
              data.data.extname === '.xlsx' ||
              data.data.extname === '.xls' ||
              data.data.extname === '.pptx' ||
              data.data.extname === '.ppt'
            "
          >
            <i class="pen">
              <svg style="width: 17px; height: 17px" viewBox="0 0 24 24">
                <path
                  fill="#2c3e50"
                  d="M15.54,3.5L20.5,8.47L19.07,9.88L14.12,4.93L15.54,3.5M3.5,19.78L10,13.31C9.9,13 9.97,12.61 10.23,12.35C10.62,11.96 11.26,11.96 11.65,12.35C12.04,12.75 12.04,13.38 11.65,13.77C11.39,14.03 11,14.1 10.69,14L4.22,20.5L14.83,16.95L18.36,10.59L13.42,5.64L7.05,9.17L3.5,19.78Z"
                />
              </svg>
            </i>
            Edit File
          </li>
          <li
            @click="view_txt(data.index, data.data.id)"
            v-if="!data.data.is_dir && data.data.extname === '.txt'"
          >
            <i class="fa fa-eye"></i> View File
          </li>
          <li
            @click="play_video(data.data.id)"
            class="player"
            v-if="!data.data.is_dir && data.data.type === 'video'"
          >
            <i class="play">
              <svg style="width: 19px; height: 19px" viewBox="0 0 24 24">
                <path fill="#2c3e50" d="M8,5.14V19.14L19,12.14L8,5.14Z" />
              </svg>
              <span>Play Video</span>
            </i>
          </li>
          <li
            @click="play_audio(data.data.id)"
            class="player"
            v-if="!data.data.is_dir && data.data.type === 'audio'"
          >
            <i class="play">
              <svg style="width: 19px; height: 19px" viewBox="0 0 24 24">
                <path fill="#2c3e50" d="M8,5.14V19.14L19,12.14L8,5.14Z" />
              </svg>
              <span>Play Audio</span>
            </i>
          </li>
          <li
            @click="view_file(data.data.id)"
            class="player"
            v-if="!data.data.is_dir && data.data.type === 'image'"
          >
            <i class="play">
              <svg
                style="width: 16px; height: 16px; left: 5px"
                viewBox="0 0 24 24"
              >
                <path
                  fill="#2c3e50"
                  d="M17,18C17.56,18 18,18.44 18,19C18,19.56 17.56,20 17,20C16.44,20 16,19.56 16,19C16,18.44 16.44,18 17,18M17,15C14.27,15 11.94,16.66 11,19C11.94,21.34 14.27,23 17,23C19.73,23 22.06,21.34 23,19C22.06,16.66 19.73,15 17,15M17,21.5A2.5,2.5 0 0,1 14.5,19A2.5,2.5 0 0,1 17,16.5A2.5,2.5 0 0,1 19.5,19A2.5,2.5 0 0,1 17,21.5M9.14,19.75L8.85,19L9.14,18.26C10.43,15.06 13.5,13 17,13C18.05,13 19.06,13.21 20,13.56V8L14,2H6C4.89,2 4,2.89 4,4V20A2,2 0 0,0 6,22H10.5C9.95,21.34 9.5,20.58 9.14,19.75M13,3.5L18.5,9H13V3.5Z"
                />
              </svg>
              <span>View File</span>
            </i>
          </li>
          <li
            class="player"
            v-if="!data.data.is_dir && data.data.extname === '.pdf'"
          >
            <i class="play" @click="viewpdf(data.data.id)">
              <svg
                style="width: 16px; height: 16px; left: 5px"
                viewBox="0 0 24 24"
              >
                <path
                  fill="#2c3e50"
                  d="M17,18C17.56,18 18,18.44 18,19C18,19.56 17.56,20 17,20C16.44,20 16,19.56 16,19C16,18.44 16.44,18 17,18M17,15C14.27,15 11.94,16.66 11,19C11.94,21.34 14.27,23 17,23C19.73,23 22.06,21.34 23,19C22.06,16.66 19.73,15 17,15M17,21.5A2.5,2.5 0 0,1 14.5,19A2.5,2.5 0 0,1 17,16.5A2.5,2.5 0 0,1 19.5,19A2.5,2.5 0 0,1 17,21.5M9.14,19.75L8.85,19L9.14,18.26C10.43,15.06 13.5,13 17,13C18.05,13 19.06,13.21 20,13.56V8L14,2H6C4.89,2 4,2.89 4,4V20A2,2 0 0,0 6,22H10.5C9.95,21.34 9.5,20.58 9.14,19.75M13,3.5L18.5,9H13V3.5Z"
                />
              </svg>
              <span>View File</span>
            </i>
          </li>
          <li
            class="player"
            v-if="!data.data.is_dir && data.data.extname !== ''"
          >
            <i class="play" @click="download(data.data.id)">
              <svg style="width: 16px; height: 16px" viewBox="0 0 24 24">
                <path
                  fill="#2c3e50"
                  d="M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z"
                />
              </svg>
              <span>Download</span>
            </i>
          </li>
          <li @click="get_shareable_link()" v-if="!data.data.is_dir">
            <i class="">
              <svg style="width: 16px; height: 16px" viewBox="0 0 24 24">
                <path
                  fill="currentColor"
                  d="M3.9,12C3.9,10.29 5.29,8.9 7,8.9H11V7H7A5,5 0 0,0 2,12A5,5 0 0,0 7,17H11V15.1H7C5.29,15.1 3.9,13.71 3.9,12M8,13H16V11H8V13M17,7H13V8.9H17C18.71,8.9 20.1,10.29 20.1,12C20.1,13.71 18.71,15.1 17,15.1H13V17H17A5,5 0 0,0 22,12A5,5 0 0,0 17,7Z"
                /></svg
              >&nbsp;
              <span>Get shareable link</span>
            </i>
          </li>
          <li @click="add_comment(data.data, data.data.id)">
            <i class="fa fa-comment-alt"></i> Comments
          </li>
          <template v-if="data.data.db === 'filesystem'">
            <li
              v-if="data.data.can_move"
              @click="moveto"
              class="d-flex justify-content-start align-items-center"
            >
              <span>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.1237 4.73639L10.235 5.084H10.6H15.8333C16.3637 5.084 16.8724 5.29472 17.2475 5.66979C17.6226 6.04486 17.8333 6.55357 17.8333 7.084V15.4173C17.8333 15.9478 17.6226 16.4565 17.2475 16.8315C16.8724 17.2066 16.3637 17.4173 15.8333 17.4173H4.16663C3.63619 17.4173 3.12749 17.2066 2.75241 16.8315C2.37734 16.4565 2.16663 15.9478 2.16663 15.4173V4.584C2.16663 4.05357 2.37734 3.54486 2.75241 3.16979C3.12749 2.79472 3.63619 2.584 4.16663 2.584L7.96663 2.58401L7.96855 2.584C8.38346 2.5824 8.78859 2.70988 9.12782 2.94877C9.46512 3.18631 9.72066 3.5223 9.85951 3.91065L10.1237 4.73639ZM7.96606 3.25067H4.16663C3.813 3.25067 3.47387 3.39115 3.22382 3.64119C2.97377 3.89124 2.83329 4.23038 2.83329 4.584V15.4173C2.83329 15.771 2.97377 16.1101 3.22382 16.3601C3.47387 16.6102 3.81301 16.7507 4.16663 16.7507H15.8333C16.1869 16.7507 16.5261 16.6102 16.7761 16.3601C17.0262 16.1101 17.1666 15.771 17.1666 15.4173V7.084C17.1666 6.73038 17.0262 6.39124 16.7761 6.14119C16.5261 5.89114 16.1869 5.75067 15.8333 5.75067L9.99996 5.75067L9.99867 5.75067C9.92879 5.75085 9.86062 5.72906 9.80379 5.68839C9.74736 5.648 9.70496 5.59101 9.68247 5.52539C9.68231 5.52493 9.68216 5.52447 9.682 5.524L9.23321 4.16096L9.23322 4.16096L9.232 4.15734C9.14256 3.89251 8.97214 3.66249 8.74484 3.49979C8.51774 3.33724 8.24533 3.2501 7.96606 3.25067Z"
                    fill="#677888"
                    stroke="#677888"
                  />
                  <path
                    d="M12.3903 11.5438L12.3902 11.5438L12.3866 11.5345C12.3712 11.4949 12.3485 11.4586 12.3195 11.4276L10.6576 9.76564L10.6575 9.76564L10.6561 9.76419C10.6251 9.73294 10.5883 9.70815 10.5476 9.69122C10.507 9.6743 10.4634 9.66559 10.4194 9.66559C10.3754 9.66559 10.3319 9.6743 10.2912 9.69122C10.2506 9.70815 10.2138 9.73294 10.1828 9.76419L10.1828 9.7642L10.1799 9.76708C10.1486 9.79807 10.1238 9.83494 10.1069 9.87556L9.64536 9.68327L10.1069 9.87556C10.09 9.91618 10.0813 9.95975 10.0813 10.0038C10.0813 10.0478 10.09 10.0913 10.1069 10.1319C10.1235 10.1718 10.1477 10.208 10.1781 10.2387L10.4253 10.4776L11.3144 11.3371H10.0778H7.91944C7.83103 11.3371 7.74625 11.3722 7.68374 11.4347C7.62122 11.4972 7.5861 11.582 7.5861 11.6704C7.5861 11.7588 7.62122 11.8436 7.68374 11.9061C7.74625 11.9686 7.83103 12.0038 7.91944 12.0038H10.0778H11.3144L10.4253 12.8632L10.179 13.1013C10.1173 13.1642 10.0827 13.2489 10.0827 13.3371C10.0827 13.4264 10.1182 13.512 10.1813 13.5752C10.2445 13.6383 10.3301 13.6738 10.4194 13.6738C10.5087 13.6738 10.5944 13.6383 10.6576 13.5752L12.3195 11.9133C12.3485 11.8822 12.3712 11.8459 12.3866 11.8063L12.3865 11.8063L12.3903 11.7971C12.4236 11.7159 12.4236 11.6249 12.3903 11.5438Z"
                    fill="#677888"
                    stroke="#677888"
                  />
                </svg>
              </span>
              &nbsp;
              <span style="margin-top: 0.25em">Move to</span>
            </li>
          </template>
          <li
            v-if="data.data.can_move"
            @click="copyto"
            class="d-flex justify-content-start align-items-center"
          >
            <span>
              <svg
                width="16"
                height="18"
                viewBox="0 0 16 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.94457 1.27603L14.9317 6.26311C14.938 6.27011 14.9442 6.27732 14.95 6.28475V6.30618L14.9761 6.38374C14.9868 6.41574 14.9948 6.44858 15 6.48192V6.48197V6.48211V6.48226V6.4824V6.48254V6.48268V6.48282V6.48296V6.4831V6.48324V6.48338V6.48351V6.48365V6.48378V6.48392V6.48405V6.48418V6.48432V6.48445V6.48458V6.48471V6.48484V6.48496V6.48509V6.48522V6.48534V6.48547V6.48559V6.48572V6.48584V6.48596V6.48608V6.4862V6.48632V6.48644V6.48656V6.48668V6.4868V6.48691V6.48703V6.48714V6.48726V6.48737V6.48748V6.48759V6.48771V6.48782V6.48793V6.48803V6.48814V6.48825V6.48836V6.48846V6.48857V6.48868V6.48878V6.48888V6.48899V6.48909V6.48919V6.48929V6.48939V6.48949V6.48959V6.48969V6.48979V6.48988V6.48998V6.49007V6.49017V6.49026V6.49036V6.49045V6.49054V6.49063V6.49073V6.49082V6.49091V6.49099V6.49108V6.49117V6.49126V6.49135V6.49143V6.49152V6.4916V6.49169V6.49177V6.49185V6.49193V6.49202V6.4921V6.49218V6.49226V6.49234V6.49242V6.49249V6.49257V6.49265V6.49273V6.4928V6.49288V6.49295V6.49303V6.4931V6.49317V6.49324V6.49332V6.49339V6.49346V6.49353V6.4936V6.49367V6.49374V6.4938V6.49387V6.49394V6.494V6.49407V6.49413V6.4942V6.49426V6.49433V6.49439V6.49445V6.49451V6.49458V6.49464V6.4947V6.49476V6.49482V6.49488V6.49493V6.49499V6.49505V6.49511V6.49516V6.49522V6.49527V6.49533V6.49538V6.49544V6.49549V6.49554V6.49559V6.49565V6.4957V6.49575V6.4958V6.49585V6.4959V6.49595V6.496V6.49604V6.49609V6.49614V6.49619V6.49623V6.49628V6.49632V6.49637V6.49641V6.49646V6.4965V6.49654V6.49659V6.49663V6.49667V6.49671V6.49675V6.49679V6.49683V6.49687V6.49691V6.49695V6.49699V6.49703V6.49707V6.4971V6.49714V6.49718V6.49721V6.49725V6.49728V6.49732V6.49735V6.49739V6.49742V6.49745V6.49749V6.49752V6.49755V6.49758V6.49761V6.49764V6.49768V6.49771V6.49774V6.49777V6.49779V6.49782V6.49785V6.49788V6.49791V6.49793V6.49796V6.49799V6.49801V6.49804V6.49807V6.49809V6.49812V6.49814V6.49817V6.49819V6.49821V6.49824V6.49826V6.49828V6.4983V6.49833V6.49835V6.49837V6.49839V6.49841V6.49843V6.49845V6.49847V6.49849V6.49851V6.49853V6.49855V6.49857V6.49859V6.4986V6.49862V6.49864V6.49866V6.49867V6.49869V6.49871V6.49872V6.49874V6.49875V6.49877V6.49878V6.4988V6.49881V6.49883V6.49884V6.49885V6.49887V6.49888V6.49889V6.49891V6.49892V6.49893V6.49894V6.49895V6.49897V6.49898V6.49899V6.499V6.49901V6.49902V6.49903V6.49904V6.49905V6.49906V6.49907V6.49908V6.49909V6.4991V6.4991V6.49911V6.49912V6.49913V6.49914V6.49914V6.49915V6.49916V6.49917V6.49918V6.49919V6.4992V6.49922V6.49923V6.49924V6.49925V6.49926V6.49926V6.49927V6.49928V6.49929V6.4993V6.49931V6.49931V6.49932V6.49933V6.49934V6.49935V11.4993C15 12.0298 14.7893 12.5385 14.4142 12.9136C14.0391 13.2886 13.5304 13.4993 13 13.4993H12.1667H11.6667V13.9993V14.8327C11.6667 15.3631 11.456 15.8718 11.0809 16.2469C10.7058 16.622 10.1971 16.8327 9.66667 16.8327H3C2.46957 16.8327 1.96086 16.622 1.58579 16.2469C1.21071 15.8718 1 15.3631 1 14.8327V6.49935C1 5.96892 1.21071 5.46021 1.58579 5.08514C1.96086 4.71006 2.46957 4.49935 3 4.49935H3.83333H4.33333V3.99935V3.16602C4.33333 2.63558 4.54405 2.12688 4.91912 1.7518C5.29419 1.37673 5.8029 1.16602 6.33333 1.16602H9.66897C9.69196 1.17111 9.71409 1.17966 9.73459 1.19142L9.88359 1.27687L9.93698 1.26928C9.93954 1.2715 9.94207 1.27375 9.94457 1.27603ZM10.8536 3.15413L10 2.30058V3.50768V4.83268C10 5.1863 10.1405 5.52544 10.3905 5.77549C10.6406 6.02554 10.9797 6.16602 11.3333 6.16602H12.6583H13.8654L13.0119 5.31246L10.8536 3.15413ZM4.33333 5.66602V5.16602H3.83333H3C2.64638 5.16602 2.30724 5.30649 2.05719 5.55654C1.80714 5.80659 1.66667 6.14573 1.66667 6.49935V14.8327C1.66667 15.1863 1.80714 15.5254 2.05719 15.7755C2.30724 16.0255 2.64638 16.166 3 16.166H9.66667C10.0203 16.166 10.3594 16.0255 10.6095 15.7755C10.8595 15.5254 11 15.1863 11 14.8327V13.9993V13.4993H10.5H6.33333C5.8029 13.4993 5.29419 13.2886 4.91912 12.9136C4.54405 12.5385 4.33333 12.0298 4.33333 11.4993V5.66602ZM9.33333 2.33268V1.83268H8.83333H6.33333C5.97971 1.83268 5.64057 1.97316 5.39052 2.22321C5.14048 2.47326 5 2.81239 5 3.16602V11.4993C5 11.853 5.14048 12.1921 5.39052 12.4422C5.64057 12.6922 5.97971 12.8327 6.33333 12.8327H13C13.3536 12.8327 13.6928 12.6922 13.9428 12.4422C14.1929 12.1921 14.3333 11.853 14.3333 11.4993V7.33268V6.83268H13.8333H11.3333C10.8029 6.83268 10.2942 6.62197 9.91912 6.2469C9.54405 5.87182 9.33333 5.36312 9.33333 4.83268V2.33268Z"
                  fill="#677888"
                  stroke="#677888"
                />
              </svg>
            </span>
            &nbsp;
            <span style="margin-top: 0.2em">Copy to</span>
          </li>
          <li class="line-div"></li>
          <li
            v-if="!data.data.is_public"
            @click="sharefile"
            class="d-flex justify-content-start align-items-center"
          >
            <template v-if="!data.data.is_dir">
              <span>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.2241 12.355L11.5769 12.5176L11.8216 12.2159C12.0853 11.8909 12.4177 11.6283 12.7949 11.447C13.1716 11.266 13.5838 11.1706 14.0017 11.1676C14.5615 11.1679 15.1087 11.3341 15.5741 11.6451C16.0401 11.9564 16.4032 12.3989 16.6177 12.9166C16.8321 13.4344 16.8882 14.0041 16.7789 14.5537C16.6696 15.1033 16.3997 15.6081 16.0035 16.0044C15.6072 16.4006 15.1024 16.6705 14.5528 16.7798C14.0031 16.8891 13.4335 16.833 12.9157 16.6186C12.398 16.4041 11.9555 16.041 11.6442 15.575C11.3334 15.11 11.1673 14.5633 11.1667 14.004C11.169 13.8351 11.1857 13.6668 11.2166 13.5007L11.2878 13.1178L10.934 12.955L6.53404 10.93L6.22147 10.7862L5.97544 11.0267C5.57671 11.4166 5.07178 11.6802 4.52393 11.7844C3.97608 11.8885 3.40966 11.8287 2.89564 11.6124C2.38163 11.3961 1.94287 11.033 1.63435 10.5684C1.32583 10.1039 1.16125 9.55858 1.16125 9.00091C1.16125 8.44324 1.32583 7.89797 1.63435 7.43341C1.94287 6.96886 2.38163 6.60568 2.89564 6.38938C3.40966 6.17308 3.97608 6.11327 4.52393 6.21746C5.07178 6.32165 5.57671 6.58519 5.97544 6.97508L6.22147 7.21564L6.53404 7.07178L10.934 5.04678L11.2878 4.88398L11.2166 4.50113C11.1856 4.33442 11.1689 4.16536 11.1666 3.9958C11.1615 3.32834 11.3922 2.68049 11.818 2.16646L11.4329 1.84749L11.818 2.16646C12.244 1.65216 12.8381 1.30488 13.4953 1.18593C14.1524 1.06698 14.8305 1.184 15.4098 1.51633C15.9891 1.84866 16.4324 2.37495 16.6614 3.0023C16.8904 3.62965 16.8905 4.31775 16.6616 4.94514C16.4327 5.57254 15.9895 6.0989 15.4102 6.43134C14.831 6.76378 14.153 6.88092 13.4958 6.76209C12.8386 6.64326 12.2445 6.29609 11.8183 5.78187L11.5731 5.48598L11.2241 5.6468L6.97409 7.60513L6.56987 7.79139L6.70804 8.21446C6.87492 8.72548 6.87492 9.27634 6.70804 9.78736L6.56987 10.2104L6.97409 10.3967L11.2241 12.355ZM15.2037 2.19939C14.8474 1.96132 14.4285 1.83424 14 1.83424C13.4254 1.83424 12.8743 2.06252 12.4679 2.46884C12.0616 2.87517 11.8333 3.42627 11.8333 4.00091C11.8333 4.42944 11.9604 4.84834 12.1985 5.20464C12.4366 5.56095 12.7749 5.83866 13.1709 6.00265C13.5668 6.16664 14.0024 6.20955 14.4227 6.12594C14.843 6.04234 15.2291 5.83599 15.5321 5.53297C15.8351 5.22996 16.0414 4.8439 16.125 4.42361C16.2086 4.00331 16.1657 3.56767 16.0017 3.17176C15.8378 2.77586 15.56 2.43747 15.2037 2.19939ZM2.79627 10.8024C3.15257 11.0405 3.57148 11.1676 4 11.1676C4.57464 11.1676 5.12574 10.9393 5.53207 10.533C5.9384 10.1266 6.16667 9.57555 6.16667 9.00091C6.16667 8.57238 6.0396 8.15348 5.80152 7.79717C5.56344 7.44087 5.22506 7.16316 4.82915 6.99917C4.43324 6.83518 3.9976 6.79227 3.57731 6.87587C3.15701 6.95948 2.77095 7.16583 2.46794 7.46884C2.16492 7.77186 1.95857 8.15792 1.87497 8.57821C1.79137 8.99851 1.83427 9.43415 1.99826 9.83006C2.16225 10.226 2.43996 10.5644 2.79627 10.8024ZM12.7963 15.8024C13.1526 16.0405 13.5715 16.1676 14 16.1676C14.5746 16.1676 15.1257 15.9393 15.5321 15.533C15.9384 15.1266 16.1667 14.5755 16.1667 14.0009C16.1667 13.5724 16.0396 13.1535 15.8015 12.7972C15.5634 12.4409 15.2251 12.1632 14.8292 11.9992C14.4332 11.8352 13.9976 11.7923 13.5773 11.8759C13.157 11.9595 12.771 12.1658 12.4679 12.4688C12.1649 12.7719 11.9586 13.1579 11.875 13.5782C11.7914 13.9985 11.8343 14.4342 11.9983 14.8301C12.1623 15.226 12.44 15.5644 12.7963 15.8024Z"
                    fill="#677888"
                    stroke="#677888"
                  />
                </svg>
              </span>
              &nbsp;
              <span style="margin-top: 0.2em">Share file</span>
            </template>
            <template v-else>
              <span>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.2241 12.355L11.5769 12.5176L11.8216 12.2159C12.0853 11.8909 12.4177 11.6283 12.7949 11.447C13.1716 11.266 13.5838 11.1706 14.0017 11.1676C14.5615 11.1679 15.1087 11.3341 15.5741 11.6451C16.0401 11.9564 16.4032 12.3989 16.6177 12.9166C16.8321 13.4344 16.8882 14.0041 16.7789 14.5537C16.6696 15.1033 16.3997 15.6081 16.0035 16.0044C15.6072 16.4006 15.1024 16.6705 14.5528 16.7798C14.0031 16.8891 13.4335 16.833 12.9157 16.6186C12.398 16.4041 11.9555 16.041 11.6442 15.575C11.3334 15.11 11.1673 14.5633 11.1667 14.004C11.169 13.8351 11.1857 13.6668 11.2166 13.5007L11.2878 13.1178L10.934 12.955L6.53404 10.93L6.22147 10.7862L5.97544 11.0267C5.57671 11.4166 5.07178 11.6802 4.52393 11.7844C3.97608 11.8885 3.40966 11.8287 2.89564 11.6124C2.38163 11.3961 1.94287 11.033 1.63435 10.5684C1.32583 10.1039 1.16125 9.55858 1.16125 9.00091C1.16125 8.44324 1.32583 7.89797 1.63435 7.43341C1.94287 6.96886 2.38163 6.60568 2.89564 6.38938C3.40966 6.17308 3.97608 6.11327 4.52393 6.21746C5.07178 6.32165 5.57671 6.58519 5.97544 6.97508L6.22147 7.21564L6.53404 7.07178L10.934 5.04678L11.2878 4.88398L11.2166 4.50113C11.1856 4.33442 11.1689 4.16536 11.1666 3.9958C11.1615 3.32834 11.3922 2.68049 11.818 2.16646L11.4329 1.84749L11.818 2.16646C12.244 1.65216 12.8381 1.30488 13.4953 1.18593C14.1524 1.06698 14.8305 1.184 15.4098 1.51633C15.9891 1.84866 16.4324 2.37495 16.6614 3.0023C16.8904 3.62965 16.8905 4.31775 16.6616 4.94514C16.4327 5.57254 15.9895 6.0989 15.4102 6.43134C14.831 6.76378 14.153 6.88092 13.4958 6.76209C12.8386 6.64326 12.2445 6.29609 11.8183 5.78187L11.5731 5.48598L11.2241 5.6468L6.97409 7.60513L6.56987 7.79139L6.70804 8.21446C6.87492 8.72548 6.87492 9.27634 6.70804 9.78736L6.56987 10.2104L6.97409 10.3967L11.2241 12.355ZM15.2037 2.19939C14.8474 1.96132 14.4285 1.83424 14 1.83424C13.4254 1.83424 12.8743 2.06252 12.4679 2.46884C12.0616 2.87517 11.8333 3.42627 11.8333 4.00091C11.8333 4.42944 11.9604 4.84834 12.1985 5.20464C12.4366 5.56095 12.7749 5.83866 13.1709 6.00265C13.5668 6.16664 14.0024 6.20955 14.4227 6.12594C14.843 6.04234 15.2291 5.83599 15.5321 5.53297C15.8351 5.22996 16.0414 4.8439 16.125 4.42361C16.2086 4.00331 16.1657 3.56767 16.0017 3.17176C15.8378 2.77586 15.56 2.43747 15.2037 2.19939ZM2.79627 10.8024C3.15257 11.0405 3.57148 11.1676 4 11.1676C4.57464 11.1676 5.12574 10.9393 5.53207 10.533C5.9384 10.1266 6.16667 9.57555 6.16667 9.00091C6.16667 8.57238 6.0396 8.15348 5.80152 7.79717C5.56344 7.44087 5.22506 7.16316 4.82915 6.99917C4.43324 6.83518 3.9976 6.79227 3.57731 6.87587C3.15701 6.95948 2.77095 7.16583 2.46794 7.46884C2.16492 7.77186 1.95857 8.15792 1.87497 8.57821C1.79137 8.99851 1.83427 9.43415 1.99826 9.83006C2.16225 10.226 2.43996 10.5644 2.79627 10.8024ZM12.7963 15.8024C13.1526 16.0405 13.5715 16.1676 14 16.1676C14.5746 16.1676 15.1257 15.9393 15.5321 15.533C15.9384 15.1266 16.1667 14.5755 16.1667 14.0009C16.1667 13.5724 16.0396 13.1535 15.8015 12.7972C15.5634 12.4409 15.2251 12.1632 14.8292 11.9992C14.4332 11.8352 13.9976 11.7923 13.5773 11.8759C13.157 11.9595 12.771 12.1658 12.4679 12.4688C12.1649 12.7719 11.9586 13.1579 11.875 13.5782C11.7914 13.9985 11.8343 14.4342 11.9983 14.8301C12.1623 15.226 12.44 15.5644 12.7963 15.8024Z"
                    fill="#677888"
                    stroke="#677888"
                  />
                </svg>
              </span>
              &nbsp;
              <span style="margin-top: 0.2em">Share folder</span>
            </template>
          </li>
          <li
            @click="add_favourite(data.data.id)"
            v-if="!data.data.is_favourite"
          >
            <i class="fa fa-star"></i> Add to favourite
          </li>
          <li
            @click="remove_favourite(data.data.id)"
            v-if="data.data.is_favourite"
          >
            <i class="fa fa-star"></i> Remove from favourite
          </li>
          <template v-if="data.data.can_pin == true">
            <li v-if="!data.data.unpin" @click="pinfile(data.data.id)">
              <i class="pin">
                <svg style="width: 17px; height: 17px" viewBox="0 0 24 24">
                  <path
                    fill="#333"
                    d="M16,12V4H17V2H7V4H8V12L6,14V16H11.2V22H12.8V16H18V14L16,12Z"
                  />
                </svg>
              </i>
              Pin to home screen
            </li>
            <li v-if="data.data.unpin" @click="unpinfile(data.data.id)">
              <i class="pin">
                <svg style="width: 17px; height: 17px" viewBox="0 0 24 24">
                  <path
                    fill="#333"
                    d="M16,12V4H17V2H7V4H8V12L6,14V16H11.2V22H12.8V16H18V14L16,12Z"
                  />
                </svg>
              </i>
              Unpin from home screen
            </li>
          </template>
          <li class="line-div"></li>
          <li
            v-if="
              data.data.extname !== '.gz' &&
              data.data.extname !== '.zip' &&
              data.data.extname !== '.tar'
            "
            @click="compressfile(data.data.id)"
          >
            <i class="fa fa-file-archive"></i> Compress
          </li>
          <li
            v-if="
              data.data.extname == '.gz' ||
              data.data.extname == '.zip' ||
              data.data.extname == '.tar'
            "
            @click="uncompressfile()"
          >
            <i class="uncompress">
              <svg style="width: 18px; height: 18px" viewBox="0 0 24 24">
                <path
                  fill="#333"
                  d="M12.6,2.86C15.27,4.1 18,5.39 20.66,6.63C20.81,6.7 21,6.75 21,6.95C21,7.15 20.81,7.19 20.66,7.26C18,8.5 15.3,9.77 12.62,11C12.21,11.21 11.79,11.21 11.38,11C8.69,9.76 6,8.5 3.32,7.25C3.18,7.19 3,7.14 3,6.94C3,6.76 3.18,6.71 3.31,6.65C6,5.39 8.74,4.1 11.44,2.85C11.73,2.72 12.3,2.73 12.6,2.86M12,21.15C11.8,21.15 11.66,21.07 11.38,20.97C8.69,19.73 6,18.47 3.33,17.22C3.19,17.15 3,17.11 3,16.9C3,16.7 3.19,16.66 3.34,16.59C3.78,16.38 4.23,16.17 4.67,15.96C5.12,15.76 5.56,15.76 6,15.97C7.79,16.8 9.57,17.63 11.35,18.46C11.79,18.67 12.23,18.66 12.67,18.46C14.45,17.62 16.23,16.79 18,15.96C18.44,15.76 18.87,15.75 19.29,15.95C19.77,16.16 20.24,16.39 20.71,16.61C20.78,16.64 20.85,16.68 20.91,16.73C21.04,16.83 21.04,17 20.91,17.08C20.83,17.14 20.74,17.19 20.65,17.23C18,18.5 15.33,19.72 12.66,20.95C12.46,21.05 12.19,21.15 12,21.15M12,16.17C11.9,16.17 11.55,16.07 11.36,16C8.68,14.74 6,13.5 3.34,12.24C3.2,12.18 3,12.13 3,11.93C3,11.72 3.2,11.68 3.35,11.61C3.8,11.39 4.25,11.18 4.7,10.97C5.13,10.78 5.56,10.78 6,11C7.78,11.82 9.58,12.66 11.38,13.5C11.79,13.69 12.21,13.69 12.63,13.5C14.43,12.65 16.23,11.81 18.04,10.97C18.45,10.78 18.87,10.78 19.29,10.97C19.76,11.19 20.24,11.41 20.71,11.63C20.77,11.66 20.84,11.69 20.9,11.74C21.04,11.85 21.04,12 20.89,12.12C20.84,12.16 20.77,12.19 20.71,12.22C18,13.5 15.31,14.75 12.61,16C12.42,16.09 12.08,16.17 12,16.17Z"
                />
              </svg>
            </i>
            Uncompress {{ str_text(data.data.dir) }}
          </li>
          <template
            v-if="data.data.db === 'public' || data.data.db === 'group'"
          >
            <li
              @click="renamefile(data.data.id)"
              v-if="$store.getters.USER == data.data.user_id"
            >
              <i class="rename">
                <svg style="width: 15px; height: 15px" viewBox="0 0 24 24">
                  <path
                    fill="#000000"
                    d="M17,7H22V17H17V19A1,1 0 0,0 18,20H20V22H17.5C16.95,22 16,21.55 16,21C16,21.55 15.05,22 14.5,22H12V20H14A1,1 0 0,0 15,19V5A1,1 0 0,0 14,4H12V2H14.5C15.05,2 16,2.45 16,3C16,2.45 16.95,2 17.5,2H20V4H18A1,1 0 0,0 17,5V7M2,7H13V9H4V15H13V17H2V7M20,15V9H17V15H20Z"
                  />
                </svg>
              </i>
              Rename
            </li>
          </template>
          <template v-if="data.data.db === 'filesystem'">
            <li @click="renamefile(data.data.id)">
              <i class="rename">
                <svg style="width: 15px; height: 15px" viewBox="0 0 24 24">
                  <path
                    fill="#000000"
                    d="M17,7H22V17H17V19A1,1 0 0,0 18,20H20V22H17.5C16.95,22 16,21.55 16,21C16,21.55 15.05,22 14.5,22H12V20H14A1,1 0 0,0 15,19V5A1,1 0 0,0 14,4H12V2H14.5C15.05,2 16,2.45 16,3C16,2.45 16.95,2 17.5,2H20V4H18A1,1 0 0,0 17,5V7M2,7H13V9H4V15H13V17H2V7M20,15V9H17V15H20Z"
                  />
                </svg>
              </i>
              Rename
            </li>
          </template>
          <template
            v-if="data.data.db === 'public' || data.data.db === 'group'"
          >
            <templete v-if="$store.getters.USER == data.data.user_id">
              <li
                @click="deletefile(data.data.id)"
              >
                <i class="fa fa-trash"></i> Delete
              </li>
            </templete>
            <template v-if="$store.getters.ISSUPERADMIN">
              <li
                @click="deletefilepermanently(data.data.id)"
              >
                <i class="fa fa-trash"></i> Delete
              </li>
            </template>
          </template>
          <template v-if="data.data.db === 'filesystem'">
            <li @click="deletefile(data.data.id)">
              <i class="fa fa-trash"></i> Delete
            </li>
          </template>
          <li @click="file_info()">
            <i class="rename">
              <svg style="width: 15px; height: 15px" viewBox="0 0 24 24">
                <path
                  fill="#000000"
                  d="M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M11,17H13V11H11V17Z"
                />
              </svg> </i
            >File Info
          </li>
        </ul>
      </template>
      <template v-if="data.data.is_group && data.data.is_group_parent != true">
        <ul @click="close2">
          <li
            @click="view_doc_file"
            v-if="
              (!data.data.is_dir && data.data.extname === '.docx') ||
              data.data.extname === '.doc' ||
              data.data.extname === '.xlsx' ||
              data.data.extname === '.xls' ||
              data.data.extname === '.pptx' ||
              data.data.extname === '.ppt'
            "
          >
            <i class="fa fa-eye"></i> View File
          </li>
          <template v-if="data.data.edit_right == true">
            <li
              @click="edit_doc_file"
              v-if="
                (!data.data.is_dir && data.data.extname === '.docx') ||
                data.data.extname === '.doc' ||
                data.data.extname === '.xlsx' ||
                data.data.extname === '.xls' ||
                data.data.extname === '.pptx' ||
                data.data.extname === '.ppt'
              "
            >
              <i class="pen">
                <svg style="width: 17px; height: 17px" viewBox="0 0 24 24">
                  <path
                    fill="#2c3e50"
                    d="M15.54,3.5L20.5,8.47L19.07,9.88L14.12,4.93L15.54,3.5M3.5,19.78L10,13.31C9.9,13 9.97,12.61 10.23,12.35C10.62,11.96 11.26,11.96 11.65,12.35C12.04,12.75 12.04,13.38 11.65,13.77C11.39,14.03 11,14.1 10.69,14L4.22,20.5L14.83,16.95L18.36,10.59L13.42,5.64L7.05,9.17L3.5,19.78Z"
                  />
                </svg>
              </i>
              Edit File
            </li>
          </template>
          <li
            @click="view_txt(data.index, data.data.id)"
            v-if="!data.data.is_dir && data.data.extname === '.txt'"
          >
            <i class="fa fa-eye"></i> View File
          </li>
          <li
            @click="play_video(data.data.id)"
            class="player"
            v-if="!data.data.is_dir && data.data.type === 'video'"
          >
            <i class="play">
              <svg style="width: 19px; height: 19px" viewBox="0 0 24 24">
                <path fill="#2c3e50" d="M8,5.14V19.14L19,12.14L8,5.14Z" />
              </svg>
              <span>Play Video</span>
            </i>
          </li>
          <li
            @click="play_audio(data.data.id)"
            class="player"
            v-if="!data.data.is_dir && data.data.type === 'audio'"
          >
            <i class="play">
              <svg style="width: 19px; height: 19px" viewBox="0 0 24 24">
                <path fill="#2c3e50" d="M8,5.14V19.14L19,12.14L8,5.14Z" />
              </svg>
              <span>Play Audio</span>
            </i>
          </li>
          <li
            @click="view_file(data.data.id)"
            class="player"
            v-if="!data.data.is_dir && data.data.type === 'image'"
          >
            <i class="play">
              <svg
                style="width: 16px; height: 16px; left: 5px"
                viewBox="0 0 24 24"
              >
                <path
                  fill="#2c3e50"
                  d="M17,18C17.56,18 18,18.44 18,19C18,19.56 17.56,20 17,20C16.44,20 16,19.56 16,19C16,18.44 16.44,18 17,18M17,15C14.27,15 11.94,16.66 11,19C11.94,21.34 14.27,23 17,23C19.73,23 22.06,21.34 23,19C22.06,16.66 19.73,15 17,15M17,21.5A2.5,2.5 0 0,1 14.5,19A2.5,2.5 0 0,1 17,16.5A2.5,2.5 0 0,1 19.5,19A2.5,2.5 0 0,1 17,21.5M9.14,19.75L8.85,19L9.14,18.26C10.43,15.06 13.5,13 17,13C18.05,13 19.06,13.21 20,13.56V8L14,2H6C4.89,2 4,2.89 4,4V20A2,2 0 0,0 6,22H10.5C9.95,21.34 9.5,20.58 9.14,19.75M13,3.5L18.5,9H13V3.5Z"
                />
              </svg>
              <span>View File</span>
            </i>
          </li>
          <li
            class="player"
            v-if="!data.data.is_dir && data.data.extname === '.pdf'"
          >
            <i class="play" @click="viewpdf(data.data.id)">
              <svg
                style="width: 16px; height: 16px; left: 5px"
                viewBox="0 0 24 24"
              >
                <path
                  fill="#2c3e50"
                  d="M17,18C17.56,18 18,18.44 18,19C18,19.56 17.56,20 17,20C16.44,20 16,19.56 16,19C16,18.44 16.44,18 17,18M17,15C14.27,15 11.94,16.66 11,19C11.94,21.34 14.27,23 17,23C19.73,23 22.06,21.34 23,19C22.06,16.66 19.73,15 17,15M17,21.5A2.5,2.5 0 0,1 14.5,19A2.5,2.5 0 0,1 17,16.5A2.5,2.5 0 0,1 19.5,19A2.5,2.5 0 0,1 17,21.5M9.14,19.75L8.85,19L9.14,18.26C10.43,15.06 13.5,13 17,13C18.05,13 19.06,13.21 20,13.56V8L14,2H6C4.89,2 4,2.89 4,4V20A2,2 0 0,0 6,22H10.5C9.95,21.34 9.5,20.58 9.14,19.75M13,3.5L18.5,9H13V3.5Z"
                />
              </svg>
              <span>View File</span>
            </i>
          </li>
          <template v-if="data.data.download_right == true">
            <li
              class="player"
              v-if="!data.data.is_dir && data.data.extname !== ''"
            >
              <i class="play" @click="download(data.data.id)">
                <svg style="width: 16px; height: 16px" viewBox="0 0 24 24">
                  <path
                    fill="#2c3e50"
                    d="M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z"
                  />
                </svg>
                <span>Download</span>
              </i>
            </li>
          </template>
          <li @click="add_comment(data.data, data.data.id)">
            <i class="fa fa-comment-alt"></i> Comments
          </li>
          <template v-if="data.data.download_right">
            <li v-if="data.data.can_move" @click="copyto">
              <i class="fa fa-copy"></i> Copy to
            </li>
          </template>
          <li class="line-div"></li>
          <li
            @click="add_favourite(data.data.id)"
            v-if="!data.data.is_favourite"
          >
            <i class="fa fa-star"></i> Add to favourite
          </li>
          <li
            @click="remove_favourite(data.data.id)"
            v-if="data.data.is_favourite"
          >
            <i class="fa fa-star"></i> Remove from favourite
          </li>
          <template v-if="data.data.can_pin == true">
            <li v-if="!data.data.unpin" @click="pinfile(data.data.id)">
              <i class="pin">
                <svg style="width: 17px; height: 17px" viewBox="0 0 24 24">
                  <path
                    fill="#333"
                    d="M16,12V4H17V2H7V4H8V12L6,14V16H11.2V22H12.8V16H18V14L16,12Z"
                  />
                </svg>
              </i>
              Pin to home
            </li>
            <li v-if="data.data.unpin" @click="unpinfile(data.data.id)">
              <i class="pin">
                <svg style="width: 17px; height: 17px" viewBox="0 0 24 24">
                  <path
                    fill="#333"
                    d="M16,12V4H17V2H7V4H8V12L6,14V16H11.2V22H12.8V16H18V14L16,12Z"
                  />
                </svg>
              </i>
              Unpin from home
            </li>
          </template>
          <li class="line-div"></li>
          <li
            v-if="
              data.data.extname !== '.gz' &&
              data.data.extname !== '.zip' &&
              data.data.extname !== '.tar'
            "
            @click="compressfile(data.data.id)"
          >
            <i class="fa fa-file-archive"></i> Compress
          </li>
          <li
            v-if="
              data.data.extname == '.gz' ||
              data.data.extname == '.zip' ||
              data.data.extname == '.tar'
            "
            @click="uncompressfile()"
          >
            <i class="uncompress">
              <svg style="width: 18px; height: 18px" viewBox="0 0 24 24">
                <path
                  fill="#333"
                  d="M12.6,2.86C15.27,4.1 18,5.39 20.66,6.63C20.81,6.7 21,6.75 21,6.95C21,7.15 20.81,7.19 20.66,7.26C18,8.5 15.3,9.77 12.62,11C12.21,11.21 11.79,11.21 11.38,11C8.69,9.76 6,8.5 3.32,7.25C3.18,7.19 3,7.14 3,6.94C3,6.76 3.18,6.71 3.31,6.65C6,5.39 8.74,4.1 11.44,2.85C11.73,2.72 12.3,2.73 12.6,2.86M12,21.15C11.8,21.15 11.66,21.07 11.38,20.97C8.69,19.73 6,18.47 3.33,17.22C3.19,17.15 3,17.11 3,16.9C3,16.7 3.19,16.66 3.34,16.59C3.78,16.38 4.23,16.17 4.67,15.96C5.12,15.76 5.56,15.76 6,15.97C7.79,16.8 9.57,17.63 11.35,18.46C11.79,18.67 12.23,18.66 12.67,18.46C14.45,17.62 16.23,16.79 18,15.96C18.44,15.76 18.87,15.75 19.29,15.95C19.77,16.16 20.24,16.39 20.71,16.61C20.78,16.64 20.85,16.68 20.91,16.73C21.04,16.83 21.04,17 20.91,17.08C20.83,17.14 20.74,17.19 20.65,17.23C18,18.5 15.33,19.72 12.66,20.95C12.46,21.05 12.19,21.15 12,21.15M12,16.17C11.9,16.17 11.55,16.07 11.36,16C8.68,14.74 6,13.5 3.34,12.24C3.2,12.18 3,12.13 3,11.93C3,11.72 3.2,11.68 3.35,11.61C3.8,11.39 4.25,11.18 4.7,10.97C5.13,10.78 5.56,10.78 6,11C7.78,11.82 9.58,12.66 11.38,13.5C11.79,13.69 12.21,13.69 12.63,13.5C14.43,12.65 16.23,11.81 18.04,10.97C18.45,10.78 18.87,10.78 19.29,10.97C19.76,11.19 20.24,11.41 20.71,11.63C20.77,11.66 20.84,11.69 20.9,11.74C21.04,11.85 21.04,12 20.89,12.12C20.84,12.16 20.77,12.19 20.71,12.22C18,13.5 15.31,14.75 12.61,16C12.42,16.09 12.08,16.17 12,16.17Z"
                />
              </svg>
            </i>
            Uncompress {{ str_text(data.data.dir) }}
          </li>
          <li
            @click="renamefile(data.data.id)"
            v-if="$store.getters.USER == data.data.user_id"
          >
            <i class="rename">
              <svg style="width: 15px; height: 15px" viewBox="0 0 24 24">
                <path
                  fill="#000000"
                  d="M17,7H22V17H17V19A1,1 0 0,0 18,20H20V22H17.5C16.95,22 16,21.55 16,21C16,21.55 15.05,22 14.5,22H12V20H14A1,1 0 0,0 15,19V5A1,1 0 0,0 14,4H12V2H14.5C15.05,2 16,2.45 16,3C16,2.45 16.95,2 17.5,2H20V4H18A1,1 0 0,0 17,5V7M2,7H13V9H4V15H13V17H2V7M20,15V9H17V15H20Z"
                />
              </svg>
            </i>
            Rename
          </li>
          <template v-if="$store.getters.ISSUPERADMIN">
            <li
              @click="deletefile(data.data.id)"
            >
              <i class="fa fa-trash"></i> Delete
            </li>
          </template>
          <template v-else>
            <li
              @click="deletefile(data.data.id)"
              v-if="$store.getters.USER == data.data.user_id"
            >
              <i class="fa fa-trash"></i> Delete
            </li>
          </template>
          <li @click="file_info()">
            <i class="rename">
              <svg style="width: 15px; height: 15px" viewBox="0 0 24 24">
                <path
                  fill="#000000"
                  d="M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M11,17H13V11H11V17Z"
                />
              </svg> </i
            >File Info
          </li>
        </ul>
      </template>
      <template v-if="data.data.is_group && data.data.is_group_parent == true">
        <ul @click="close2" ref="menu">
          <template v-if="data.data.group == 'GROUP'">
            <li
              v-if="data.data.action"
              @click="adduser(data.data.id, data.data.dir)"
            >
              <i class="fa fa-user-plus"></i> Add User
            </li>
          </template>
          <li
            v-if="data.data.action"
            @click="edituser(data.data.id, data.data.dir)"
          >
            <i class="fa fa-user-edit"></i> Edit User
          </li>
          <li @click="deletefile(data.data.id)" v-if="!data.data.is_approved">
            <i class="fa fa-trash"></i> Delete
          </li>
          <li @click="file_info()">
            <i class="rename">
              <svg style="width: 15px; height: 15px" viewBox="0 0 24 24">
                <path
                  fill="#000000"
                  d="M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M11,17H13V11H11V17Z"
                />
              </svg> </i
            >File Info
          </li>
        </ul>
      </template>
    </template>
    <template v-if="data.data.db == 'sharedfiles'">
      <ul @click="close2" ref="menu">
        <li @click="edit_file_access">
          <i class="rename">
            <svg style="width: 15px; height: 15px" viewBox="0 0 24 24">
              <path
                fill="#000000"
                d="M22 17V16.5C22 15.12 20.88 14 19.5 14S17 15.12 17 16.5V17C16.45 17 16 17.45 16 18V22C16 22.55 16.45 23 17 23H22C22.55 23 23 22.55 23 22V18C23 17.45 22.55 17 22 17M21 17H18V16.5C18 15.67 18.67 15 19.5 15S21 15.67 21 16.5V17M8 8C8 5.79 9.79 4 12 4S16 5.79 16 8 14.21 12 12 12 8 10.21 8 8M14 20H4V18C4 15.79 7.58 14 12 14C13.27 14 14.46 14.15 15.53 14.41C15.32 14.82 15.15 15.25 15.07 15.71C14.42 16.26 14 17.08 14 18V20Z"
              />
            </svg>
          </i>
          <template v-if="data.data.is_dir"> Edit Folder Access </template>
          <template v-else> Edit File Access </template>
        </li>
        <li
            @click="sharefile"
            class="d-flex justify-content-start align-items-center"
          >
            <template v-if="!data.data.is_dir">
              <span>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.2241 12.355L11.5769 12.5176L11.8216 12.2159C12.0853 11.8909 12.4177 11.6283 12.7949 11.447C13.1716 11.266 13.5838 11.1706 14.0017 11.1676C14.5615 11.1679 15.1087 11.3341 15.5741 11.6451C16.0401 11.9564 16.4032 12.3989 16.6177 12.9166C16.8321 13.4344 16.8882 14.0041 16.7789 14.5537C16.6696 15.1033 16.3997 15.6081 16.0035 16.0044C15.6072 16.4006 15.1024 16.6705 14.5528 16.7798C14.0031 16.8891 13.4335 16.833 12.9157 16.6186C12.398 16.4041 11.9555 16.041 11.6442 15.575C11.3334 15.11 11.1673 14.5633 11.1667 14.004C11.169 13.8351 11.1857 13.6668 11.2166 13.5007L11.2878 13.1178L10.934 12.955L6.53404 10.93L6.22147 10.7862L5.97544 11.0267C5.57671 11.4166 5.07178 11.6802 4.52393 11.7844C3.97608 11.8885 3.40966 11.8287 2.89564 11.6124C2.38163 11.3961 1.94287 11.033 1.63435 10.5684C1.32583 10.1039 1.16125 9.55858 1.16125 9.00091C1.16125 8.44324 1.32583 7.89797 1.63435 7.43341C1.94287 6.96886 2.38163 6.60568 2.89564 6.38938C3.40966 6.17308 3.97608 6.11327 4.52393 6.21746C5.07178 6.32165 5.57671 6.58519 5.97544 6.97508L6.22147 7.21564L6.53404 7.07178L10.934 5.04678L11.2878 4.88398L11.2166 4.50113C11.1856 4.33442 11.1689 4.16536 11.1666 3.9958C11.1615 3.32834 11.3922 2.68049 11.818 2.16646L11.4329 1.84749L11.818 2.16646C12.244 1.65216 12.8381 1.30488 13.4953 1.18593C14.1524 1.06698 14.8305 1.184 15.4098 1.51633C15.9891 1.84866 16.4324 2.37495 16.6614 3.0023C16.8904 3.62965 16.8905 4.31775 16.6616 4.94514C16.4327 5.57254 15.9895 6.0989 15.4102 6.43134C14.831 6.76378 14.153 6.88092 13.4958 6.76209C12.8386 6.64326 12.2445 6.29609 11.8183 5.78187L11.5731 5.48598L11.2241 5.6468L6.97409 7.60513L6.56987 7.79139L6.70804 8.21446C6.87492 8.72548 6.87492 9.27634 6.70804 9.78736L6.56987 10.2104L6.97409 10.3967L11.2241 12.355ZM15.2037 2.19939C14.8474 1.96132 14.4285 1.83424 14 1.83424C13.4254 1.83424 12.8743 2.06252 12.4679 2.46884C12.0616 2.87517 11.8333 3.42627 11.8333 4.00091C11.8333 4.42944 11.9604 4.84834 12.1985 5.20464C12.4366 5.56095 12.7749 5.83866 13.1709 6.00265C13.5668 6.16664 14.0024 6.20955 14.4227 6.12594C14.843 6.04234 15.2291 5.83599 15.5321 5.53297C15.8351 5.22996 16.0414 4.8439 16.125 4.42361C16.2086 4.00331 16.1657 3.56767 16.0017 3.17176C15.8378 2.77586 15.56 2.43747 15.2037 2.19939ZM2.79627 10.8024C3.15257 11.0405 3.57148 11.1676 4 11.1676C4.57464 11.1676 5.12574 10.9393 5.53207 10.533C5.9384 10.1266 6.16667 9.57555 6.16667 9.00091C6.16667 8.57238 6.0396 8.15348 5.80152 7.79717C5.56344 7.44087 5.22506 7.16316 4.82915 6.99917C4.43324 6.83518 3.9976 6.79227 3.57731 6.87587C3.15701 6.95948 2.77095 7.16583 2.46794 7.46884C2.16492 7.77186 1.95857 8.15792 1.87497 8.57821C1.79137 8.99851 1.83427 9.43415 1.99826 9.83006C2.16225 10.226 2.43996 10.5644 2.79627 10.8024ZM12.7963 15.8024C13.1526 16.0405 13.5715 16.1676 14 16.1676C14.5746 16.1676 15.1257 15.9393 15.5321 15.533C15.9384 15.1266 16.1667 14.5755 16.1667 14.0009C16.1667 13.5724 16.0396 13.1535 15.8015 12.7972C15.5634 12.4409 15.2251 12.1632 14.8292 11.9992C14.4332 11.8352 13.9976 11.7923 13.5773 11.8759C13.157 11.9595 12.771 12.1658 12.4679 12.4688C12.1649 12.7719 11.9586 13.1579 11.875 13.5782C11.7914 13.9985 11.8343 14.4342 11.9983 14.8301C12.1623 15.226 12.44 15.5644 12.7963 15.8024Z"
                    fill="#677888"
                    stroke="#677888"
                  />
                </svg>
              </span>
              &nbsp;
              <span style="margin-top: 0.2em">Share file</span>
            </template>
            <template v-else>
              <span>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.2241 12.355L11.5769 12.5176L11.8216 12.2159C12.0853 11.8909 12.4177 11.6283 12.7949 11.447C13.1716 11.266 13.5838 11.1706 14.0017 11.1676C14.5615 11.1679 15.1087 11.3341 15.5741 11.6451C16.0401 11.9564 16.4032 12.3989 16.6177 12.9166C16.8321 13.4344 16.8882 14.0041 16.7789 14.5537C16.6696 15.1033 16.3997 15.6081 16.0035 16.0044C15.6072 16.4006 15.1024 16.6705 14.5528 16.7798C14.0031 16.8891 13.4335 16.833 12.9157 16.6186C12.398 16.4041 11.9555 16.041 11.6442 15.575C11.3334 15.11 11.1673 14.5633 11.1667 14.004C11.169 13.8351 11.1857 13.6668 11.2166 13.5007L11.2878 13.1178L10.934 12.955L6.53404 10.93L6.22147 10.7862L5.97544 11.0267C5.57671 11.4166 5.07178 11.6802 4.52393 11.7844C3.97608 11.8885 3.40966 11.8287 2.89564 11.6124C2.38163 11.3961 1.94287 11.033 1.63435 10.5684C1.32583 10.1039 1.16125 9.55858 1.16125 9.00091C1.16125 8.44324 1.32583 7.89797 1.63435 7.43341C1.94287 6.96886 2.38163 6.60568 2.89564 6.38938C3.40966 6.17308 3.97608 6.11327 4.52393 6.21746C5.07178 6.32165 5.57671 6.58519 5.97544 6.97508L6.22147 7.21564L6.53404 7.07178L10.934 5.04678L11.2878 4.88398L11.2166 4.50113C11.1856 4.33442 11.1689 4.16536 11.1666 3.9958C11.1615 3.32834 11.3922 2.68049 11.818 2.16646L11.4329 1.84749L11.818 2.16646C12.244 1.65216 12.8381 1.30488 13.4953 1.18593C14.1524 1.06698 14.8305 1.184 15.4098 1.51633C15.9891 1.84866 16.4324 2.37495 16.6614 3.0023C16.8904 3.62965 16.8905 4.31775 16.6616 4.94514C16.4327 5.57254 15.9895 6.0989 15.4102 6.43134C14.831 6.76378 14.153 6.88092 13.4958 6.76209C12.8386 6.64326 12.2445 6.29609 11.8183 5.78187L11.5731 5.48598L11.2241 5.6468L6.97409 7.60513L6.56987 7.79139L6.70804 8.21446C6.87492 8.72548 6.87492 9.27634 6.70804 9.78736L6.56987 10.2104L6.97409 10.3967L11.2241 12.355ZM15.2037 2.19939C14.8474 1.96132 14.4285 1.83424 14 1.83424C13.4254 1.83424 12.8743 2.06252 12.4679 2.46884C12.0616 2.87517 11.8333 3.42627 11.8333 4.00091C11.8333 4.42944 11.9604 4.84834 12.1985 5.20464C12.4366 5.56095 12.7749 5.83866 13.1709 6.00265C13.5668 6.16664 14.0024 6.20955 14.4227 6.12594C14.843 6.04234 15.2291 5.83599 15.5321 5.53297C15.8351 5.22996 16.0414 4.8439 16.125 4.42361C16.2086 4.00331 16.1657 3.56767 16.0017 3.17176C15.8378 2.77586 15.56 2.43747 15.2037 2.19939ZM2.79627 10.8024C3.15257 11.0405 3.57148 11.1676 4 11.1676C4.57464 11.1676 5.12574 10.9393 5.53207 10.533C5.9384 10.1266 6.16667 9.57555 6.16667 9.00091C6.16667 8.57238 6.0396 8.15348 5.80152 7.79717C5.56344 7.44087 5.22506 7.16316 4.82915 6.99917C4.43324 6.83518 3.9976 6.79227 3.57731 6.87587C3.15701 6.95948 2.77095 7.16583 2.46794 7.46884C2.16492 7.77186 1.95857 8.15792 1.87497 8.57821C1.79137 8.99851 1.83427 9.43415 1.99826 9.83006C2.16225 10.226 2.43996 10.5644 2.79627 10.8024ZM12.7963 15.8024C13.1526 16.0405 13.5715 16.1676 14 16.1676C14.5746 16.1676 15.1257 15.9393 15.5321 15.533C15.9384 15.1266 16.1667 14.5755 16.1667 14.0009C16.1667 13.5724 16.0396 13.1535 15.8015 12.7972C15.5634 12.4409 15.2251 12.1632 14.8292 11.9992C14.4332 11.8352 13.9976 11.7923 13.5773 11.8759C13.157 11.9595 12.771 12.1658 12.4679 12.4688C12.1649 12.7719 11.9586 13.1579 11.875 13.5782C11.7914 13.9985 11.8343 14.4342 11.9983 14.8301C12.1623 15.226 12.44 15.5644 12.7963 15.8024Z"
                    fill="#677888"
                    stroke="#677888"
                  />
                </svg>
              </span>
              &nbsp;
              <span style="margin-top: 0.2em">Share folder</span>
            </template>
        </li>
        <li @click="file_info()">
          <i class="rename">
            <svg style="width: 15px; height: 15px" viewBox="0 0 24 24">
              <path
                fill="#000000"
                d="M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M11,17H13V11H11V17Z"
              />
            </svg> </i
          >File Info
        </li>
        <li @click="deletesharedfile()">
          <i class="fa fa-trash"></i>
          <template v-if="data.data.is_dir"> Delete Shared Folder </template>
          <template v-else> Delete Shared File </template>
        </li>
      </ul>
    </template>
    <template v-if="data.data.db == 'sharedwithme'">
      <ul @click="close2" ref="menu">
        <li
          @click="view_doc_file"
          v-if="
            (!data.data.is_dir && data.data.extname === '.docx') ||
            data.data.extname === '.doc' ||
            data.data.extname === '.xlsx' ||
            data.data.extname === '.xls' ||
            data.data.extname === '.pptx' ||
            data.data.extname === '.ppt'
          "
        >
          <i class="fa fa-eye"></i> View File
        </li>
        <template v-if="data.data.edit">
          <li
            @click="edit_doc_file"
            v-if="
              (!data.data.is_dir && data.data.extname === '.docx') ||
              data.data.extname === '.doc' ||
              data.data.extname === '.xlsx' ||
              data.data.extname === '.xls' ||
              data.data.extname === '.pptx' ||
              data.data.extname === '.ppt'
            "
          >
            <i class="pen">
              <svg style="width: 17px; height: 17px" viewBox="0 0 24 24">
                <path
                  fill="#2c3e50"
                  d="M15.54,3.5L20.5,8.47L19.07,9.88L14.12,4.93L15.54,3.5M3.5,19.78L10,13.31C9.9,13 9.97,12.61 10.23,12.35C10.62,11.96 11.26,11.96 11.65,12.35C12.04,12.75 12.04,13.38 11.65,13.77C11.39,14.03 11,14.1 10.69,14L4.22,20.5L14.83,16.95L18.36,10.59L13.42,5.64L7.05,9.17L3.5,19.78Z"
                />
              </svg>
            </i>
            Edit File
          </li>
        </template>
        <li
          @click="view_txt(data.index, data.data.file_id)"
          v-if="!data.data.is_dir && data.data.extname === '.txt'"
        >
          <i class="fa fa-eye"></i> View File
        </li>
        <li
          v-if="data.data.edit"
          @click="add_comment(data.data, data.data.file_id)"
        >
          <i class="fa fa-comment-alt"></i> Comments
        </li>
        <li
          @click="play_video(data.data.file_id)"
          class="player"
          v-if="!data.data.is_dir && data.data.type === 'video'"
        >
          <i class="play">
            <svg style="width: 19px; height: 19px" viewBox="0 0 24 24">
              <path fill="#2c3e50" d="M8,5.14V19.14L19,12.14L8,5.14Z" />
            </svg>
            <span>Play Video</span>
          </i>
        </li>
        <li
          @click="play_audio(data.data.file_id)"
          class="player"
          v-if="!data.data.is_dir && data.data.type === 'audio'"
        >
          <i class="play">
            <svg style="width: 19px; height: 19px" viewBox="0 0 24 24">
              <path fill="#2c3e50" d="M8,5.14V19.14L19,12.14L8,5.14Z" />
            </svg>
            <span>Play Audio</span>
          </i>
        </li>
        <li
          @click="view_file(data.data.file_id)"
          class="player"
          v-if="!data.data.is_dir && data.data.type === 'image'"
        >
          <i class="play">
            <svg
              style="width: 16px; height: 16px; left: 5px"
              viewBox="0 0 24 24"
            >
              <path
                fill="#2c3e50"
                d="M17,18C17.56,18 18,18.44 18,19C18,19.56 17.56,20 17,20C16.44,20 16,19.56 16,19C16,18.44 16.44,18 17,18M17,15C14.27,15 11.94,16.66 11,19C11.94,21.34 14.27,23 17,23C19.73,23 22.06,21.34 23,19C22.06,16.66 19.73,15 17,15M17,21.5A2.5,2.5 0 0,1 14.5,19A2.5,2.5 0 0,1 17,16.5A2.5,2.5 0 0,1 19.5,19A2.5,2.5 0 0,1 17,21.5M9.14,19.75L8.85,19L9.14,18.26C10.43,15.06 13.5,13 17,13C18.05,13 19.06,13.21 20,13.56V8L14,2H6C4.89,2 4,2.89 4,4V20A2,2 0 0,0 6,22H10.5C9.95,21.34 9.5,20.58 9.14,19.75M13,3.5L18.5,9H13V3.5Z"
              />
            </svg>
            <span>View File</span>
          </i>
        </li>
        <li
          class="player"
          v-if="!data.data.is_dir && data.data.extname === '.pdf'"
        >
          <i class="play" @click="viewpdf(data.data.file_id)">
            <svg
              style="width: 16px; height: 16px; left: 5px"
              viewBox="0 0 24 24"
            >
              <path
                fill="#2c3e50"
                d="M17,18C17.56,18 18,18.44 18,19C18,19.56 17.56,20 17,20C16.44,20 16,19.56 16,19C16,18.44 16.44,18 17,18M17,15C14.27,15 11.94,16.66 11,19C11.94,21.34 14.27,23 17,23C19.73,23 22.06,21.34 23,19C22.06,16.66 19.73,15 17,15M17,21.5A2.5,2.5 0 0,1 14.5,19A2.5,2.5 0 0,1 17,16.5A2.5,2.5 0 0,1 19.5,19A2.5,2.5 0 0,1 17,21.5M9.14,19.75L8.85,19L9.14,18.26C10.43,15.06 13.5,13 17,13C18.05,13 19.06,13.21 20,13.56V8L14,2H6C4.89,2 4,2.89 4,4V20A2,2 0 0,0 6,22H10.5C9.95,21.34 9.5,20.58 9.14,19.75M13,3.5L18.5,9H13V3.5Z"
              />
            </svg>
            <span>View File</span>
          </i>
        </li>
        <template v-if="data.data.download">
          <li
            class="player"
            v-if="!data.data.is_dir && data.data.extname !== ''"
          >
            <i class="play" @click="downloadshared(data.data.file_id)">
              <svg style="width: 16px; height: 16px" viewBox="0 0 24 24">
                <path
                  fill="#2c3e50"
                  d="M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z"
                />
              </svg>
              <span>Download</span>
            </i>
          </li>
        </template>
        <template v-if="data.data.download">
          <li
            class="player"
            v-if="!data.data.is_dir && data.data.extname !== ''"
          >
            <i class="play" @click="copyshared(data.data.file_id)">
              <i class="fa fa-copy"></i> <span>Copy to</span>
            </i>
          </li>
        </template>
        <template v-if="data.data.edit">
          <li @click="add_comment(data.data, data.data.file_id)">
            <i class="fa fa-comment-alt"></i> Comments
          </li>
        </template>
        <li
          v-if="!data.data.is_favourite"
          @click="add_shared_file_to_fav(data.data)"
        >
          <i class="fa fa-star"></i> Add to favourite
        </li>
        <li
          v-if="data.data.is_favourite"
          @click="remove_shared_file_to_fav(data.data)"
        >
          <i class="fa fa-star"></i> Remove from favourite
        </li>
        <!--<li v-if="data.data.delete">
                    <i class="fa fa-trash"></i> Delete File
                </li>-->
        <li @click="file_info()">
          <i class="rename">
            <svg style="width: 15px; height: 15px" viewBox="0 0 24 24">
              <path
                fill="#000000"
                d="M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M11,17H13V11H11V17Z"
              />
            </svg> </i
          >File Info
        </li>
      </ul>
    </template>
    <template v-if="data.data.db == 'trash'">
      <ul @click="close2" ref="menu">
        <li @click="restorefile()">
          <i class="rename">
            <svg style="width: 18px; height: 18px" viewBox="0 0 24 24">
              <path
                fill="#000000"
                d="M10.5,7A6.5,6.5 0 0,0 4,13.5A6.5,6.5 0 0,0 10.5,20H14V18H10.5C8,18 6,16 6,13.5C6,11 8,9 10.5,9H16.17L13.09,12.09L14.5,13.5L20,8L14.5,2.5L13.08,3.91L16.17,7H10.5M18,18H16V20H18V18Z"
              />
            </svg> </i
          >Restore File
        </li>
        <li @click="deletefilepermanently()">
          <i class="fa fa-trash"></i> Delete
        </li>
      </ul>
    </template>
  </div>
</template>
<script>
import config from "@/services/config";
import cookies from "@/services/cookies";
import { mapMutations } from "vuex";
import AuthenticationService from "@/services/AuthenticationService";

export default {
  props: {
    data: {
      data: Object,
      index: Number,
    },
  },
  data() {
    return {};
  },
  methods: {
    ...mapMutations([
      "SET_FILE_ACTION",
      "REMOVE_FILE_ACTION",
      "SET_DIRECTORY_CHILDREN",
      "TOGGLE_FILE_INFO",
      "SORT_DIRECTORY_CHILDREN",
      "SORT_STORED_DIRECTORY_CHILDREN",
      "SET_STORED_DIRECTORY_CHILDREN",
      "SET_FILE_INFO_DATA",
      "SET_CURRENT_FILE_ID",
      "SET_CURRENT_DIRECTORY",
      "SET_PATH",
      "HIDE_FILE_INFO",
      "SET_FILE_INDEX",
      "SET_FILES_INDEX",
      "SET_SELECT_ALL",
      "REMOVE_FILES_INDEX",
      "EMPTY_FILES_INDEX",
      "SET_SELECT_ALL",
      "SET_DB",
      "SET_CAN_CREATE",
      "SET_CREATE_RIGHT",
      "SET_EDIT_RIGHT",
      "SET_DOWNLOAD_RIGHT",
      "SET_PRINT_RIGHT",
      "SET_GROUP_CREATE_MODE",
    ]),
    view_doc_file() {
      let a = document.createElement("a");
      if (this.data.data.db === "group") {
        a.setAttribute(
          "href",
          process.env.VUE_APP_HTTP +
            "://" +
            location.host +
            "/group-view-doc/" +
            this.data.data.id
        );
      }

      if (this.data.data.db === "sharedwithme") {
        AuthenticationService.updatesharedfileviewstatus({
          id: this.data.data.id,
          token: cookies.getCookie("token"),
        })
          .then((res) => {
            console.log(res);
          })
          .catch((err) => {
            console.log(err);
          });

        a.setAttribute(
          "href",
          process.env.VUE_APP_HTTP +
            "://" +
            location.host +
            "/shared-view-doc/" +
            this.data.data.id
        );
      }

      if (this.data.data.db === "public") {
        a.setAttribute(
          "href",
          process.env.VUE_APP_HTTP +
            "://" +
            location.host +
            "/view-doc/" +
            this.data.data.id
        );
      }

      if (this.data.data.db === "filesystem") {
        a.setAttribute(
          "href",
          process.env.VUE_APP_HTTP +
            "://" +
            location.host +
            "/view-doc/" +
            this.data.data.id
        );
      }
      a.setAttribute("target", "_blank");
      a.hidden = true;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    edit_doc_file() {
      if (this.$store.getters.ISTRIAL) {
        if (!this.$store.getters.TRIAL_STATUS) {
          if (this.$store.getters.ISSTAFF) {
            this.$parent.notifyexpiration(
              "Your trial period has expired. <br/>Please contact your admin"
            );
            return;
          } else {
            this.$parent.notifyexpiration(
              'Your trial period has expired. <a href="/payments-billing">Payments & Billing</a>'
            );
            return;
          }
        }
      } else {
        if (!this.$store.getters.PLAN_STATUS) {
          if (this.$store.getters.ISSTAFF) {
            this.$parent.notifyexpiration(
              "Your trial period has expired.. <br/>Please contact your admin"
            );
            return;
          } else {
            this.$parent.notifyexpiration(
              'Your trial period has expired.. <a href="/payments-billing">Payments & Billing</a>'
            );
            return;
          }
        }
      }

      let a = document.createElement("a");
      if (this.data.data.db === "group") {
        a.setAttribute(
          "href",
          process.env.VUE_APP_HTTP +
            "://" +
            location.host +
            "/group-edit-doc/" +
            this.data.data.id
        );
      }

      if (this.data.data.db === "sharedwithme") {
        AuthenticationService.updatesharedfileviewstatus({
          id: this.data.data.id,
          token: cookies.getCookie("token"),
        })
          .then((res) => {
            console.log(res);
          })
          .catch((err) => {
            console.log(err);
          });
        a.setAttribute(
          "href",
          process.env.VUE_APP_HTTP +
            "://" +
            location.host +
            "/shared-edit-doc/" +
            this.data.data.id
        );
      }

      if (this.data.data.db === "public") {
        a.setAttribute(
          "href",
          process.env.VUE_APP_HTTP +
            "://" +
            location.host +
            "/edit-doc/" +
            this.data.data.id
        );
      }

      if (this.data.data.db === "filesystem") {
        a.setAttribute(
          "href",
          process.env.VUE_APP_HTTP +
            "://" +
            location.host +
            "/edit-doc/" +
            this.data.data.id
        );
      }
      a.setAttribute("target", "_blank");
      a.hidden = true;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    loader() {
      this.$parent.load();
    },
    close_loader() {
      this.$parent.close_load();
    },
    logincall() {
      this.$parent.logincall();
    },
    str_text(str) {
      if (str.length > 24) {
        let fSeg = str.substring(0, 5);
        let sSeg = str.substr(str.length - 12, 4);

        return fSeg + "...." + sSeg;
      }

      return str;
    },
    adduser(id, folderName) {
      if (this.$store.getters.ISTRIAL) {
        if (!this.$store.getters.TRIAL_STATUS) {
          if (this.$store.getters.ISSTAFF) {
            this.$parent.notifyexpiration(
              "Your trial period has expired. <br/>Please contact your admin"
            );
            return;
          } else {
            this.$parent.notifyexpiration(
              'Your trial period has expired. <a href="/payments-billing">Payments & Billing</a>'
            );
            return;
          }
        }
      } else {
        if (!this.$store.getters.PLAN_STATUS) {
          if (this.$store.getters.ISSTAFF) {
            this.$parent.notifyexpiration(
              "Your trial period has expired.. <br/>Please contact your admin"
            );
            return;
          } else {
            this.$parent.notifyexpiration(
              'Your trial period has expired.. <a href="/payments-billing">Payments & Billing</a>'
            );
            return;
          }
        }
      }
      this.$parent.addusertofolder(id, folderName);
    },
    edituser(id, folderName) {
      if (this.$store.getters.ISTRIAL) {
        if (!this.$store.getters.TRIAL_STATUS) {
          if (this.$store.getters.ISSTAFF) {
            this.$parent.notifyexpiration(
              "Your trial period has expired. <br/>Please contact your admin"
            );
            return;
          } else {
            this.$parent.notifyexpiration(
              'Your trial period has expired. <a href="/payments-billing">Payments & Billing</a>'
            );
            return;
          }
        }
      } else {
        if (!this.$store.getters.PLAN_STATUS) {
          if (this.$store.getters.ISSTAFF) {
            this.$parent.notifyexpiration(
              "Your trial period has expired.. <br/>Please contact your admin"
            );
            return;
          } else {
            this.$parent.notifyexpiration(
              'Your trial period has expired.. <a href="/payments-billing">Payments & Billing</a>'
            );
            return;
          }
        }
      }
      this.$parent.editusertofolder(id, folderName);
    },
    close(e) {
      if (e.target.nodeName === "LI" || e.target.nodeName === "I") {
        this.data.data.show = false;
      }
    },
    close2(e) {
      this.data.data.show = false;
    },
    get_shareable_link() {
      if (this.$store.getters.ISTRIAL) {
        if (!this.$store.getters.TRIAL_STATUS) {
          if (this.$store.getters.ISSTAFF) {
            this.$parent.notifyexpiration(
              "Your trial period has expired. <br/>Please contact your admin"
            );
            return;
          } else {
            this.$parent.notifyexpiration(
              'Your trial period has expired. <a href="/payments-billing">Payments & Billing</a>'
            );
            return;
          }
        }
      } else {
        if (!this.$store.getters.PLAN_STATUS) {
          if (this.$store.getters.ISSTAFF) {
            this.$parent.notifyexpiration(
              "Your trial period has expired.. <br/>Please contact your admin"
            );
            return;
          } else {
            this.$parent.notifyexpiration(
              'Your trial period has expired.. <a href="/payments-billing">Payments & Billing</a>'
            );
            return;
          }
        }
      }

      let link = this.data.data.sharelink
      let a = document.createElement('input')

      a.setAttribute('value', link)
      a.setAttribute('id', 'link')
      a.click()
      a.style.position = 'absolute'
      a.style.left = '-9999px'
      document.body.appendChild(a)
      let l = document.getElementById('link')
      l.select()
      document.execCommand('copy')
      document.body.removeChild(a)

      this.data.data.show = false

      let data = {
        token: cookies.getCookie('token'),
        id: this.data.data.id,
        link
      }

      let that = this

      this.$socket.emit('save-link', data, function (data) {
        if (data.data === true) {
          that.$toast.open({
            message: '<svg style="width:24px;height:24px" viewBox="0 0 24 24"><path fill="currentColor" d="M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" /></svg> Link copied to clipboad',
            type: 'info',
            position: 'bottom-left'
          })
        }

        if (data.data === false) {
          that.logincall()
        }
      })

      // this.$parent.shareable_dialog(this.data.data.sharelink, this.data.data.id)
    },
    sharefile() {
      if (this.$store.getters.ISTRIAL) {
        if (!this.$store.getters.TRIAL_STATUS) {
          if (this.$store.getters.ISSTAFF) {
            this.$parent.notifyexpiration(
              "Your trial period has expired. <br/>Please contact your admin"
            );
            return;
          } else {
            this.$parent.notifyexpiration(
              'Your trial period has expired. <a href="/payments-billing">Payments & Billing</a>'
            );
            return;
          }
        }
      } else {
        if (!this.$store.getters.PLAN_STATUS) {
          if (this.$store.getters.ISSTAFF) {
            this.$parent.notifyexpiration(
              "Your trial period has expired.. <br/>Please contact your admin"
            );
            return;
          } else {
            this.$parent.notifyexpiration(
              'Your trial period has expired.. <a href="/payments-billing">Payments & Billing</a>'
            );
            return;
          }
        }
      }

      this.$parent.sharefile(this.data.index);
    },
    viewpdf(id) {
      this.$parent.viewpdf(id, this.data.data);
    },
    view_txt(index, id) {
      this.$parent.view_txt(index, id);
    },
    edit_txt(id) {
      this.$parent.edit_txt(this.data.index, id);
    },
    view_file(id) {
      this.$parent.view_file(this.data.index, id);
    },
    play_video(id) {
      this.$parent.play_video(this.data.index, id);
    },
    play_audio(id) {
      this.$parent.play_audio(this.data.index, id);
    },
    deletefilepermanently() {
      if (this.$store.getters.ISTRIAL) {
        if (!this.$store.getters.TRIAL_STATUS) {
          if (this.$store.getters.ISSTAFF) {
            this.$parent.notifyexpiration(
              "Your trial period has expired. <br/>Please contact your admin"
            );
            return;
          } else {
            this.$parent.notifyexpiration(
              'Your trial period has expired. <a href="/payments-billing">Payments & Billing</a>'
            );
            return;
          }
        }
      } else {
        if (!this.$store.getters.PLAN_STATUS) {
          if (this.$store.getters.ISSTAFF) {
            this.$parent.notifyexpiration(
              "Your trial period has expired.. <br/>Please contact your admin"
            );
            return;
          } else {
            this.$parent.notifyexpiration(
              'Your trial period has expired.. <a href="/payments-billing">Payments & Billing</a>'
            );
            return;
          }
        }
      }
      this.$parent.deletefilepermanently(this.data.index, "prompt");
    },
    restorefile() {
      this.$parent.restorefile(this.data.index);
    },
    deletefile(id) {
      this.$parent.deletefile(this.data.index, id, "");
    },
    add_favourite(id) {
      this.$parent.add_favourite(this.data.index, id);
    },
    remove_favourite(id) {
      this.$parent.remove_favourite(this.data.index, id);
    },
    add_shared_file_to_fav(d) {
      this.$parent.add_favourite(this.data.index, d.file_id);
    },
    remove_shared_file_to_fav(d) {
      this.$parent.remove_favourite(this.data.index, d.file_id);
    },
    pinfile(id) {
      if (this.$store.getters.ISTRIAL) {
        if (!this.$store.getters.TRIAL_STATUS) {
          if (this.$store.getters.ISSTAFF) {
            this.$parent.notifyexpiration(
              "Your trial period has expired. <br/>Please contact your admin"
            );
            return;
          } else {
            this.$parent.notifyexpiration(
              'Your trial period has expired. <a href="/payments-billing">Payments & Billing</a>'
            );
            return;
          }
        }
      } else {
        if (!this.$store.getters.PLAN_STATUS) {
          if (this.$store.getters.ISSTAFF) {
            this.$parent.notifyexpiration(
              "Your subscription has expired. <br/>Please contact your admin"
            );
            return;
          } else {
            this.$parent.notifyexpiration(
              'Your subscription has expired. <a href="/payments-billing">Payments & Billing</a>'
            );
            return;
          }
        }
      }
      this.$parent.pinfile(this.data.index, id);
    },
    unpinfile(id) {
      if (this.$store.getters.ISTRIAL) {
        if (!this.$store.getters.TRIAL_STATUS) {
          if (this.$store.getters.ISSTAFF) {
            this.$parent.notifyexpiration(
              "Your trial period has expired. <br/>Please contact your admin"
            );
            return;
          } else {
            this.$parent.notifyexpiration(
              'Your trial period has expired. <a href="/payments-billing">Payments & Billing</a>'
            );
            return;
          }
        }
      } else {
        if (!this.$store.getters.PLAN_STATUS) {
          if (this.$store.getters.ISSTAFF) {
            this.$parent.notifyexpiration(
              "Your trial period has expired.. <br/>Please contact your admin"
            );
            return;
          } else {
            this.$parent.notifyexpiration(
              'Your trial period has expired.. <a href="/payments-billing">Payments & Billing</a>'
            );
            return;
          }
        }
      }
      this.$parent.unpinfile(this.data.index, id);
    },
    add_comment(data, id) {
      if (this.$store.getters.ISTRIAL) {
        if (!this.$store.getters.TRIAL_STATUS) {
          if (this.$store.getters.ISSTAFF) {
            this.$parent.notifyexpiration(
              "Your trial period has expired. <br/>Please contact your admin"
            );
            return;
          } else {
            this.$parent.notifyexpiration(
              'Your trial period has expired. <a href="/payments-billing">Payments & Billing</a>'
            );
            return;
          }
        }
      } else {
        if (!this.$store.getters.PLAN_STATUS) {
          if (this.$store.getters.ISSTAFF) {
            this.$parent.notifyexpiration(
              "Your trial period has expired.. <br/>Please contact your admin"
            );
            return;
          } else {
            this.$parent.notifyexpiration(
              'Your trial period has expired.. <a href="/payments-billing">Payments & Billing</a>'
            );
            return;
          }
        }
      }

      AuthenticationService.updatesharedfileviewstatus({
        id: id,
        token: cookies.getCookie("token"),
      })
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });

      let filename = data.is_dir == false ? data.dir + data.extname : data.dir;
      this.$parent.add_comment(filename, id);
    },
    renamefile(id) {
      this.$parent.renamefile(this.data.index, this.data.data.dir, id);
    },
    compressfile() {
      this.$parent.compressfile(this.data.index, "single");
    },
    uncompressfile() {
      this.$parent.uncompressfile(this.data.index);
    },
    copyto() {
      if (this.$store.getters.ISTRIAL) {
        if (!this.$store.getters.TRIAL_STATUS) {
          if (this.$store.getters.ISSTAFF) {
            this.$parent.notifyexpiration(
              "Your trial period has expired. <br/>Please contact your admin"
            );
            return;
          } else {
            this.$parent.notifyexpiration(
              'Your trial period has expired. <a href="/payments-billing">Payments & Billing</a>'
            );
            return;
          }
        }
      } else {
        if (!this.$store.getters.PLAN_STATUS) {
          if (this.$store.getters.ISSTAFF) {
            this.$parent.notifyexpiration(
              "Your trial period has expired.. <br/>Please contact your admin"
            );
            return;
          } else {
            this.$parent.notifyexpiration(
              'Your trial period has expired.. <a href="/payments-billing">Payments & Billing</a>'
            );
            return;
          }
        }
      }
      this.$parent.copyto(this.data.index);
    },
    moveto() {
      if (this.$store.getters.ISTRIAL) {
        if (!this.$store.getters.TRIAL_STATUS) {
          if (this.$store.getters.ISSTAFF) {
            this.$parent.notifyexpiration(
              "Your trial period has expired. <br/>Please contact your admin"
            );
            return;
          } else {
            this.$parent.notifyexpiration(
              'Your trial period has expired. <a href="/payments-billing">Payments & Billing</a>'
            );
            return;
          }
        }
      } else {
        if (!this.$store.getters.PLAN_STATUS) {
          if (this.$store.getters.ISSTAFF) {
            this.$parent.notifyexpiration(
              "Your trial period has expired.. <br/>Please contact your admin"
            );
            return;
          } else {
            this.$parent.notifyexpiration(
              'Your trial period has expired.. <a href="/payments-billing">Payments & Billing</a>'
            );
            return;
          }
        }
      }
      this.$parent.moveto(this.data.index);
    },
    copyshared(id) {
      if (this.$store.getters.ISTRIAL) {
        if (!this.$store.getters.TRIAL_STATUS) {
          if (this.$store.getters.ISSTAFF) {
            this.$parent.notifyexpiration(
              "Your trial period has expired. <br/>Please contact your admin"
            );
            return;
          } else {
            this.$parent.notifyexpiration(
              'Your trial period has expired. <a href="/payments-billing">Payments & Billing</a>'
            );
            return;
          }
        }
      } else {
        if (!this.$store.getters.PLAN_STATUS) {
          if (this.$store.getters.ISSTAFF) {
            this.$parent.notifyexpiration(
              "Your trial period has expired.. <br/>Please contact your admin"
            );
            return;
          } else {
            this.$parent.notifyexpiration(
              'Your trial period has expired.. <a href="/payments-billing">Payments & Billing</a>'
            );
            return;
          }
        }
      }
      this.$parent.copyto(this.data.index, true);
    },
    download(id) {
      if (this.$store.getters.ISTRIAL) {
        if (!this.$store.getters.TRIAL_STATUS) {
          if (this.$store.getters.ISSTAFF) {
            this.$parent.notifyexpiration(
              "Your trial period has expired. <br/>Please contact your admin"
            );
            return;
          } else {
            this.$parent.notifyexpiration(
              'Your trial period has expired. <a href="/payments-billing">Payments & Billing</a>'
            );
            return;
          }
        }
      } else {
        if (!this.$store.getters.PLAN_STATUS) {
          if (this.$store.getters.ISSTAFF) {
            this.$parent.notifyexpiration(
              "Your trial period has expired.. <br/>Please contact your admin"
            );
            return;
          } else {
            this.$parent.notifyexpiration(
              'Your trial period has expired.. <a href="/payments-billing">Payments & Billing</a>'
            );
            return;
          }
        }
      }
      let token = cookies.getCookie("token");

      let a = document.createElement("a");
      a.setAttribute("download", true);
      let href =
        process.env.VUE_APP_NODE_ENV !== "development"
          ? process.env.VUE_APP_HTTP +
            "://" +
            config.origin +
            "/download?id=" +
            id +
            "&token=" +
            token
          : process.env.VUE_APP_HTTP +
            "://" +
            config.origin +
            ":" +
            process.env.VUE_APP_PORT +
            "/download?id=" +
            id +
            "&token=" +
            token;
      a.setAttribute("href", href);
      a.hidden = true;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    downloadshared(id) {
      if (this.$store.getters.ISTRIAL) {
        if (!this.$store.getters.TRIAL_STATUS) {
          if (this.$store.getters.ISSTAFF) {
            this.$parent.notifyexpiration(
              "Your trial period has expired. <br/>Please contact your admin"
            );
            return;
          } else {
            this.$parent.notifyexpiration(
              'Your trial period has expired. <a href="/payments-billing">Payments & Billing</a>'
            );
            return;
          }
        }
      } else {
        if (!this.$store.getters.PLAN_STATUS) {
          if (this.$store.getters.ISSTAFF) {
            this.$parent.notifyexpiration(
              "Your trial period has expired.. <br/>Please contact your admin"
            );
            return;
          } else {
            this.$parent.notifyexpiration(
              'Your trial period has expired.. <a href="/payments-billing">Payments & Billing</a>'
            );
            return;
          }
        }
      }
      let token = cookies.getCookie("token");

      let a = document.createElement("a");
      a.setAttribute("download", true);
      let href =
        process.env.VUE_APP_NODE_ENV === "development"
          ? process.env.VUE_APP_HTTP +
            "://" +
            config.origin +
            ":" +
            process.env.VUE_APP_PORT +
            "/download?id=" +
            id +
            "&token=" +
            token
          : process.env.VUE_APP_HTTP +
            "://" +
            config.origin +
            "/download?id=" +
            id +
            "&token=" +
            token;
      a.setAttribute("href", href);
      a.hidden = true;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    file_info() {
      if (this.data.data.db === "sharedwithme") {
        this.$parent.show_file_info(this.data.data);
      }

      if (this.data.data.db === "sharedfiles") {
        this.$parent.show_file_info(this.data.data);
      }

      if (this.data.data.db === "group") {
        this.$parent.show_file_info(this.data.data);
      }

      if (
        this.data.data.db !== "sharedwithme" &&
        this.data.data.db !== "sharedfiles" &&
        this.data.data.db !== "group"
      ) {
        this.$parent.show_file_info(this.data.data);
      }
    },
    open_file_location() {
      let data = {
        token: cookies.getCookie("token"),
        id: this.data.data.file_id,
      };

      this.loader();
      let that = this;

      this.$socket.emit("open-file-location", data, function (data) {
        if (data.data === true) {
          that.close_loader();

          localStorage.setItem("current_directory_id", data.current_dir_id);
          localStorage.setItem("current_directory", data.current_dir_name);
          localStorage.setItem("db", "filesystem");
          that.SET_DB("filesystem");
          that.SET_DIRECTORY_CHILDREN(data.directory_children);
          that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children);
          that.SET_CURRENT_DIRECTORY(data.current_dir_name);
          that.SET_CAN_CREATE(data.current_dir_id);
          that.SET_PATH(data.dir_path);
          that.SORT_DIRECTORY_CHILDREN();
        }

        if (data.data === false) {
          that.close_loader();
          that.logincall();
        }
      });
    },
    edit_file_access() {
      if (this.$store.getters.ISTRIAL) {
        if (!this.$store.getters.TRIAL_STATUS) {
          if (this.$store.getters.ISSTAFF) {
            this.$parent.notifyexpiration(
              "Your trial period has expired. <br/>Please contact your admin"
            );
            return;
          } else {
            this.$parent.notifyexpiration(
              'Your trial period has expired. <a href="/payments-billing">Payments & Billing</a>'
            );
            return;
          }
        }
      } else {
        if (!this.$store.getters.PLAN_STATUS) {
          if (this.$store.getters.ISSTAFF) {
            this.$parent.notifyexpiration(
              "Your trial period has expired.. <br/>Please contact your admin"
            );
            return;
          } else {
            this.$parent.notifyexpiration(
              'Your trial period has expired.. <a href="/payments-billing">Payments & Billing</a>'
            );
            return;
          }
        }
      }
      let data = {
        token: cookies.getCookie("token"),
        id: this.data.data.id,
      };

      this.$parent.editsharefileright(data, this.data.index);
    },
    deletesharedfile() {
      let data = {
        token: cookies.getCookie("token"),
        id: this.data.data.id,
      };

      let that = this;
      let index = this.data.index;

      this.loader();

      this.$socket.emit("delete-shared-file", data, function (data) {
        if (data.data === true) {
          that.$store.getters.DIRECTORY_CHILDREN.splice(index, 1);
          that.close_loader();
        }

        if (data.data === false) {
          that.close_loader();
          that.logincall();
        }
      });
    },
  },
  mounted() {},
};
</script>
